export const CREATE_BANK_ACCOUNT = 'createBankAccount'
export const UPDATE_BANK_ACCOUNT = 'updateBankAccount'
export const GET_BANK_ACCOUNTS = 'getBankAccounts'
export const PAYMENT_INIT = 'paymentInit'
export const GET_MANDATE_BINARY = 'getMandateBinary'
export const SIGN_MANDATE = 'signMandate'
export const POST_BANK_ACCOUNTS = 'postBankAccounts'
